<template>
    <div
        @click.prevent="handleToggle"
        :data-e2e="props.dataE2e"
        :class="[
            'border border-[#373737] rounded-full px-2.5 py-1.5 text-xs cursor-pointer',
            {
                'text-gray-400': !isCheckedInGroup,
                'text-white bg-gray-600 bg-opacity-50': isCheckedInGroup
            }
        ]"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
import { inject } from "vue";

interface Props {
    value?: string | number | boolean | undefined;
    modelValue?: any;
    onUpdate?: any;
    label?: string;
    name?: string;
    description?: string;
    dataE2e?: string;
}

const emit = defineEmits(["update:modelValue"]);
const checkboxGroup = inject("checkboxGroup", null);
const props = defineProps<Props>();

const isCheckedInGroup = computed(() => {
    if (checkboxGroup) {
        return checkboxGroup.selected.value.includes(props.value);
    } else {
        if (props.modelValue instanceof Array) {
            return props.modelValue.includes(props.value);
        }
        return props.modelValue;
    }
});

const handleToggle = () => {
    if (checkboxGroup) {
        checkboxGroup.updateValue(props.value);
    } else {
        let model = props.modelValue;
        if (model instanceof Array) {
            if (isCheckedInGroup.value) {
                model = model.filter(item => item !== props.value);
            } else {
                model = [...model, props.value];
            }
        } else {
            model = !model;
        }
        emit("update:modelValue", model);
    }
};
</script>
  